(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vue"), require("VueRouter"));
	else if(typeof define === 'function' && define.amd)
		define(["Vue", "VueRouter"], factory);
	else if(typeof exports === 'object')
		exports["main"] = factory(require("Vue"), require("VueRouter"));
	else
		root["main"] = factory(root["Vue"], root["VueRouter"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__18__, __WEBPACK_EXTERNAL_MODULE__32__) {
return 